<template>
  <Transition name="fade">
    <div
        v-if="store.current"
        class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
        @click.self="handleDismiss"
    >
      <div class="relative bg-white dark:bg-gray-800 rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
        <!-- Крестик -->
        <button
            type="button"
            class="absolute top-4 right-4 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors"
            aria-label="Закрыть"
            @click="handleDismiss"
        >
          <svg width="16" height="16" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
            <path d="M2.05.636 13.364 11.95l-1.414 1.414L.636 2.05z"/>
            <path d="M.636 11.95 11.95.636l1.414 1.414L2.05 13.364z"/>
          </svg>
        </button>

        <!-- Иконка -->
        <div class="flex items-center justify-center w-12 h-12 rounded-full bg-green-100 dark:bg-green-900/30 mb-4">
          <span class="mdi mdi-handshake text-2xl text-green-600 dark:text-green-400"></span>
        </div>

        <!-- Заголовок -->
        <h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          Вас выбрали исполнителем
        </h2>

        <!-- Текст -->
        <p class="text-gray-700 dark:text-gray-300 mb-1">
          <span class="font-medium">{{ store.current.ownerName || 'Заказчик' }}</span>
          выбрал(а) вас исполнителем по объявлению
        </p>
        <p class="mb-4">
          <router-link
              v-if="store.current.quickPostId"
              :to="{ name: 'QuickPostDetail', params: { id: store.current.quickPostId } }"
              class="font-medium text-indigo-600 dark:text-indigo-400 hover:underline"
              @click="handleDismiss"
          >«{{ store.current.postTitle || 'Быстрое объявление' }}»</router-link>
          <span v-else class="font-medium">«{{ store.current.postTitle || 'Быстрое объявление' }}»</span>
        </p>
        <div class="mb-6 text-sm text-gray-600 dark:text-gray-400">
          <template v-if="store.current.ownerPhone">
            Свяжитесь с заказчиком:
            <a :href="`tel:${store.current.ownerPhone}`" class="font-medium text-indigo-600 dark:text-indigo-400">
              {{ store.current.ownerPhone }}
            </a>
          </template>
          <template v-else>
            Откройте объявление, чтобы посмотреть контактные данные заказчика.
          </template>
        </div>

        <!-- Счётчик в очереди (если больше одного) -->
        <p v-if="store.queue.length > 1" class="text-xs text-gray-400 dark:text-gray-500 mb-4">
          Ещё {{ store.queue.length - 1 }} {{ pluralAssignment(store.queue.length - 1) }}
        </p>

        <!-- Кнопка -->
        <div class="flex gap-3">
          <router-link
              v-if="store.current.quickPostId"
              :to="{ name: 'QuickPostDetail', params: { id: store.current.quickPostId } }"
              class="flex-1 py-2.5 px-4 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-medium rounded-lg transition-colors text-center"
              @click="handleDismiss"
          >
            Открыть объявление
          </router-link>
          <button
              type="button"
              class="flex-1 py-2.5 px-4 border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 text-sm font-medium rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
              @click="handleDismiss"
          >
            Закрыть
          </button>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script setup>
import { usePerformerSelectionStore } from '@/modules/quick_post/store/performerSelectionStore.js';

const store = usePerformerSelectionStore();

function handleDismiss() {
    store.dismissCurrent();
}

function pluralAssignment(n) {
    if (n === 1) return 'назначение';
    if (n >= 2 && n <= 4) return 'назначения';
    return 'назначений';
}
</script>
